// Some endpoints (the futures/balance ones) now reply with a structured
// { code, message } body on failure instead of a plain string, so callers
// can no longer render `err.response.data` directly - React throws
// (Objects are not valid as a React child) when that body is an object.
// This normalizes both shapes into a plain string safe to display.
export function getErrorMessage(err) {
    const data = err && err.response ? err.response.data : err && err.message;

    if (data && typeof data === 'object')
        return data.message || 'Something went wrong.';

    return data || (err && err.message) || 'Something went wrong.';
}
